<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "contentManagerHome"
}
</script>

<style scoped>

</style>
